export default __webpack_public_path__ + "static/DO-1-d5142a5026085e77fb236d63775bbb51.png";